import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';

import { CtaWidthEnum } from '~/component/call-to-action/enums/width.enum';
import { AlertModalComponent } from '~/component/modal/alert/alert.component';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { Timeslot } from '~/core/model/timeslot.model';
import { TitleService } from '~/core/services/title/title.service';
import { MessagingService } from '~/messaging/services/messaging.service';
import { BookingItemsGroupByUserIdInterface } from '~/organizer/shared/services/activity/interfaces/booking-items-group-by-user-id.interface';

@Component({
  selector: 'app-organizer-timeslot-participant-manage',
  templateUrl: './manage.component.html',
})
export class OrganizerTimeslotPageParticipantManageComponent implements OnInit {
  @ViewChild(AlertModalComponent)
  public editTimeslotDateModal: AlertModalComponent;

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly ctaWidth = CtaWidthEnum;
  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public bookingItemGroupByUserId: BookingItemsGroupByUserIdInterface;
  public timeslot: Timeslot;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly messagingService: MessagingService,
    private readonly titleService: TitleService,
    private readonly localizeRouter: LocalizeRouterService,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.titleService.setPageTitle(
      'seo.organizer.timeslot.participant.manage.title'
    );

    const { bookingItemGroupByUserId, timeslotData } =
      this.activatedRoute.snapshot.data;

    this.bookingItemGroupByUserId = bookingItemGroupByUserId;
    this.timeslot = timeslotData.timeslot;
  }

  public get backlink(): string {
    return `/organizer.timeslot.participant.list/${this.timeslot.identifier}`;
  }

  public contact(): void {
    const recipient =
      this.messagingService.buildRecipientFromBookingItemsGroupByUserId(
        this.bookingItemGroupByUserId
      );

    this.messagingService.storeRecipient(recipient);
    this.router.navigateByUrl(
      this.localizeRouter
        .translateRoute('/organizer.messaging.inbox')
        .toString()
    );
  }
}
